<template>
  <tr :class="'border-b border-gray-300 ' + (index % 2 == 0 ? 'bg-gray-100' : 'bg-white')">
    <td class="py-4 pl-6 pr-4 border-r">
      <router-link
       :to="{ 
        name : 'row-account',
        params : {
          rowId : row.id
        }
      }"
      tag="a"
      class="text-blue-600 no-underline hover:underline">{{ row.id }}</router-link>
    </td>

    <td class="p-4 border-r">{{ row.data.type }}</td>
    <td class="p-4 border-r">{{ row.data.data.object.customer }}</td>
    <td class="p-4 border-r">
      {{ row.data.data.object.email != null ? row.data.data.object.email : row.data.data.object.customer_email }}
    </td>
  </tr>
</template>

<script>

 import axios from "axios";
 import { EventBus } from '@/shared/event-bus';

  export default {

    props : {
      row : {
        type    : Object,
        required: true
      },

      index : {
        type    : Number,
        required: true
      }
    },

    methods: {
      rowSelected : function () {
        EventBus.$emit('open-row-actions', this.row)
      }

    }

  }
</script>
